import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { SocialLinks } from "@/components/SocialLinks";

const FOUNDATION_LOGO = "/brand/somkene-odabi-foundation.png";

export function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="bg-emerald-950 text-emerald-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo dark showTagline />
          <p className="mt-4 text-sm text-emerald-200/80 max-w-sm leading-relaxed">
            A national digital benefit infrastructure giving every verified beneficiary a persistent
            TMF identity and sponsor-specific entitlement — redeemable through Web, SMS, USSD and the
            TMF Vendor network anywhere in Nigeria.
          </p>
          <p className="mt-5 font-display font-bold tracking-wide text-emerald-300">FOOD. ACCESS. DIGNITY. CHOICE.</p>
          <div className="mt-5 space-y-2 text-sm text-emerald-200/80">
            <a href="mailto:info@textmefood.org" className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4" /> info@textmefood.org</a>
            <a href="tel:+2348121423424" className="flex items-center gap-2 hover:text-white"><Phone className="w-4 h-4" /> +234 812 142 3424</a>
            <a href="https://wa.me/2348121423424" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><MessageCircle className="w-4 h-4" /> WhatsApp +234 812 142 3424</a>
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3 text-sm">Explore</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li><button onClick={() => navigate("/about")} className="hover:text-white">About Us</button></li>
            <li><button onClick={() => navigate("/programmes")} className="hover:text-white">Programme Marketplace</button></li>
            <li><button onClick={() => navigate("/impact")} className="hover:text-white">Impact Dashboard</button></li>
            <li><button onClick={() => navigate("/partners")} className="hover:text-white">Development Partners</button></li>
            <li><button onClick={() => navigate("/help")} className="hover:text-white">Help Centre</button></li>
            <li><button onClick={() => navigate("/report")} className="hover:text-white">Report a Problem</button></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3 text-sm">Access Channels</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li>Web Portal</li>
            <li>USSD *7006*99#</li>
            <li>SMS Engine</li>
            <li>Vendor Terminal</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-emerald-800/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-emerald-300/70 text-center sm:text-left">
            © {new Date().getFullYear()} TMF Foundation · Nourishing Lives, Strengthening Communities
          </p>
          <SocialLinks />
          <div className="flex items-center gap-3" data-testid="footer-copyright-owner">
            <div className="text-right">
              <div className="text-[10px] uppercase tracking-widest text-emerald-300/60">Copyright Owners of TMF</div>
              <div className="text-xs font-semibold text-emerald-100">Somkene Odabi Foundation</div>
            </div>
            <div className="rounded-xl bg-white p-1.5 shadow-sm">
              <img src={FOUNDATION_LOGO} alt="Somkene Odabi Foundation" className="h-12 w-12 object-contain" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
